import { Injectable, inject } from '@angular/core';
import { TranslateLoader } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { forkJoin, Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

@Injectable()
export class MultiFileTranslateLoader implements TranslateLoader {
	private readonly http = inject(HttpClient);

	getTranslation(lang: string): Observable<object> {
		// Define the files you want to load
		const files = [
			`./assets/i18n/${lang}.json`, // Main translations
			`./assets/i18n/features/home.${lang}.json`, // Home feature
			`./assets/i18n/features/api-credentials.${lang}.json`, // API credentials feature
			`./assets/i18n/features/user-profile.${lang}.json`, // User Profile feature
			`./assets/i18n/features/dashboard.${lang}.json`, // Dashboard feature
			`./assets/i18n/features/registration-form.${lang}.json`, // Registration form
			`./assets/i18n/components/countries.${lang}.json`, // Countries
			`./assets/i18n/components/modal.${lang}.json`, // Modal component
			`./assets/i18n/components/select.${lang}.json`, // Select component
			// Add more feature files as needed
		];

		// Load all files and merge them
		const requests = files.map((file) =>
			this.http.get(file).pipe(
				map((translation) => {
					return translation || {};
				}),
				catchError((_error) => {
					return of({});
				}),
			),
		);

		return forkJoin(requests).pipe(
			map((translations) => {
				// Merge all translation objects
				const merged = translations.reduce((acc, translation) => {
					return { ...acc, ...translation };
				}, {});
				// console.log(`🔄 Merged translations for ${lang}:`, merged);
				return merged;
			}),
		);
	}
}
